// COHESION CONSTANTS
export const WRITE_KEY = process.env.environment === 'production' ? 'wk_1NT299B6zAqwtypc6ULw3pZ3vyJ' : 'wk_24yH5wA4KRm7uk2m6DWo37rMSik';
export const SOURCE_KEY = process.env.environment === 'production' ? 'src_1NT299Hykp1EOgLj96gZgh2RX5P' : 'src_24yH5vGUPks7O2KRIGUNCHZrR19';

export const DEFAULT_FUSE_NUMBER = '8664994271';
